import './styles.scss';

import PropTypes from 'prop-types';
import React, {useState} from 'react';

import closeIcon from '../../../../assets/icons/close-rounded@3x.png';
import questionMark from '../../../../assets/icons/questionIcon@3x.png';



const VoteCard = ({explanation, text, top}) => {
  const [showExplanation, setShowExplanation] = useState(false);
  return (
    <div className={`vote-card ${top ? 'top-card-bg' : 'bottom-card-bg'}`}>
      {explanation ? (
        showExplanation ? (
          <img
            src={closeIcon}
            onClick={() => setShowExplanation(!showExplanation)}
            className={'vote-card-show-explanation-button'}
            alt={'x'}
          />
        ) : (
          <img
            src={questionMark}
            onClick={() => setShowExplanation(!showExplanation)}
            className={'vote-card-show-explanation-button'}
            alt={'?'}
          />
        )
      ) : null}
      {showExplanation ? (
        <div className={'vote-card-explanation'}>
          <img className={'vote-card-question-mark'} src={questionMark} alt={'?'} />
          <div className="vote-card-text">{explanation}</div>
        </div>
      ) : (
        <div className="vote-card-text">{text}</div>
      )}
    </div>
  );
};

VoteCard.propTypes = {
  explanation: PropTypes.string,
  text: PropTypes.string.isRequired,
  top: PropTypes.bool.isRequired
};

export default VoteCard;
